<template>
  <div :class="classes" class="crop-icon">
    <component :is="icon" />
  </div>
</template>

<script>
import { kebabCase } from 'lodash';
import { defineAsyncComponent } from 'vue';
import CanolaIcon from '@/components/icons/CanolaIcon.vue';
import CottonIcon from '@/components/icons/CottonIcon.vue';
import CornIcon from '@/components/icons/CornIcon.vue';
import SoybeanIcon from '@/components/icons/SoybeanIcon.vue';
import SpringWheat from '@/components/icons/SpringWheat.vue';
import WinterWheat from '@/components/icons/WinterWheat.vue';
import AlfalfaIcon from '@/components/icons/AlfalfaIcon.vue';
import PotatoIcon from '@/components/icons/PotatoIcon.vue';
import WheatIcon from '@/components/icons/WheatIcon.vue';
import RiceIcon from '@/components/icons/RiceIcon.vue';
import CornGrain from '@/components/icons/CornGrain.vue';
import CornSilage from '@/components/icons/CornSilage.vue';

export default {
  components: {
    CanolaIcon,
    CottonIcon,
    CornIcon,
    CornGrain,
    CornSilage,
    SoybeanIcon,
    SpringWheat,
    WinterWheat,
    AlfalfaIcon,
    PotatoIcon,
    WheatIcon,
    RiceIcon
  },
  props: {
    border: {
      type: Boolean,
      required: false,
      defualt: false
    },
    crop: {
      type: String,
      required: true
    },
    theme: {
      type: String,
      required: true,
      validator: value => ['transparent', 'white', 'primary'].includes(value)
    }
  },
  computed: {
    classes() {
      const classes = [`crop-icon--${this.theme}`];

      if (this.border) {
        classes.push('crop-icon--border');
      }

      return classes;
    },
    icon() {
      const slug = this.crop.split(' ');
      let name = '';
      if (slug.length === 1) {
        name = slug[0] + 'Icon';
      } else {
        name = slug.join('');
      }
      return name;
    }
  }
};
</script>

<style lang="scss" scoped>
.crop-icon {
  align-items: center;
  display: inline-flex;
  justify-content: center;

  &--border {
    border: 1.5px solid transparent;
    height: 3.5rem;
    width: 3.5rem;

    @include breakpoint('md') {
      height: 4rem;
      width: 4rem;
    }
  }

  &--transparent {
    background-color: transparent;
    border-color: transparent;
  }

  &--white {
    background-color: color('white');
    border-color: color('gray');
    color: color('black');
  }

  &--primary {
    border-color: color('hearty-green');
    color: color('hearty-green');
    font-family: $articulat-cf;
  }

  svg {
    transform: scale(0.75);

    @include breakpoint('md') {
      transform: none;
    }
  }
}
</style>
